import React from "react";

const StaticInfo = () => {
  return <div>StaticInfo</div>;
};

export default StaticInfo;
